module.exports = __webpack_public_path__ + "img/25dfaff.svg";